import { Suspense } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { PageLoader } from '../components/ui/PageLoader'
import { contentPaths } from '../content/contentPaths'
import { pages } from './pages'
import { ProtectedRoute } from './ProtectedRoute'
import { ScrollToTop } from './ScrollToTop'

export function AppRouter() {
  return (
    <Suspense fallback={<PageLoader />}>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<pages.home />} />
        {contentPaths.map((path) => (
          <Route key={path} path={path} element={<pages.content />} />
        ))}
        <Route path="/consulta" element={<pages.consultation />} />
        <Route path="/consultacompleta" element={<pages.completeConsultation />} />
        <Route path="/entrar" element={<pages.login />} />
        <Route element={<ProtectedRoute />}>
          <Route path="/painel" element={<pages.dashboard />} />
        </Route>
        <Route path="/404" element={<pages.notFound />} />
        <Route path="*" element={<Navigate to="/404" replace />} />
      </Routes>
    </Suspense>
  )
}
